import { render } from "./Search.vue?vue&type=template&id=927d5686&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=927d5686&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-927d5686"

export default script